export default {
    API_URL: 'https://tool-flow-backend.onrender.com/api',
    OAPI_URL: 'https://tool-flow-backend.onrender.com/oapi'
}